import { render, staticRenderFns } from "./TransProStep.vue?vue&type=template&id=b9d8cec2&scoped=true&"
import script from "./TransProStep.vue?vue&type=script&lang=js&"
export * from "./TransProStep.vue?vue&type=script&lang=js&"
import style0 from "./TransProStep.vue?vue&type=style&index=0&id=b9d8cec2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d8cec2",
  null
  
)

export default component.exports